/**
 * Created by asiulik on 2016-12-13.
 */
define([
    'jquery'
], function ($) {

    var Utils = {};

    Utils.getRandomArrayElement = function (collection) {
        return collection[Math.floor(Math.random() * collection.length)];
    };

    Utils.getViewportOffset = function ($e) {

        var $window = $(window),
            scrollLeft = $window.scrollLeft(),
            scrollTop = $window.scrollTop(),
            offset = $e.offset();

        return {
            left: offset.left - scrollLeft,
            top: offset.top - scrollTop
        };
    };

    Utils.scrollPositionAnimate = function (scrollPosition, duration, $container) {

        var container = $container || $('html, body');

        return container.animate(
            {
                scrollTop: scrollPosition
            },
            duration || 700
        );
    };

    Utils.isElementInView = function (element, fullyInView) {

        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + parseInt($(element).css('height'));

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    };

    Utils.setBgImage = function (element, src) {

        if (element) {
            element.style.backgroundImage = 'url("' + src + '")';
            return element;
        }

    };

    Utils.getBgImage = function (element) {

        return element.style.backgroundImage.slice(4, -1).replace(/"/g, "");

    };

    Utils.getQueryStringParams = function (paramName, url) {

        if (!url) url = location.href;

        paramName = paramName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + paramName + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(url);
        return results == null ? null : results[1];

    };

    Utils.removeURLParameter = function (url, param)
    {
        var urlparts= url.split('?');
        if (urlparts.length>=2)
        {
            var prefix= encodeURIComponent(param)+'=';
            var pars= urlparts[1].split(/[&;]/g);
            for (var i=pars.length; i-- > 0;)
                if (pars[i].indexOf(prefix, 0)==0)
                    pars.splice(i, 1);
            if (pars.length > 0)
                return urlparts[0]+'?'+pars.join('&');
            else
                return urlparts[0];
        }
        else
            return url;
    }

    Utils.addQueryStringParamsToUrl = function(paramsName, paramData, url) {
        var urlObject = document.createElement('a');
        urlObject.href = url;
        urlObject.search = ((urlObject.search !== '') ? urlObject.search + '&' : '?') + paramsName + '=' + paramData;
        urlObject.hash = (urlObject.hash !== '') ? urlObject.hash : document.location.hash ? document.location.hash : ''
        return urlObject.href;

    }

    Utils.createPromise = function(){

        var promise = $.Deferred();
        return promise;

    };

    Utils.getPageByAjax = function(pageUrl){
        return $.ajax({
            url: pageUrl,
            type: 'GET',
            beforeSend: function () {

            },
            complete: function () {
            }
        })
    };

    Utils.getPageByAjaxLimitedToContentElements = function(url){
      return this.getPageByAjax(url).then(function(response) {
          return $(response).find('#content')
      })
    };

    Utils.fullscreen = {

        launchIntoFullscreen: function (element) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        },

        exitFullscreen: function () {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }

    };

    Utils.heightAnimation = function($element, heightValue, animationDuration, fn){

        $element.animate({ height: heightValue }, animationDuration || 400, function(){
            fn();
        })

    };

    Utils.checkFont = function(font, DOM){

        var containerA, containerB, html = document.getElementsByTagName("html")[0],
            filler = "random_words_#_!@#$^&*()_+mdvejreu_RANDOM_WORDS";

        function createContainers(){
            containerA = document.createElement("span");
            containerB = document.createElement("span");

            containerA.textContent = filler;
            containerB.textContent = filler;

            var styles = {
                margin: "0",
                padding: "0",
                fontSize: "32px",
                position: "absolute",
                zIndex: "-1"
            };

            for(var key in styles){
                if(styles.hasOwnProperty(key)){
                    containerA.style[key] = styles[key];
                    containerB.style[key] = styles[key];
                }
            }

            return function(){
                //clean up
                containerA.outerHTML = "";
                containerB.outerHTML = "";
            };
        }

        function checkDimension(){
            return containerA.offsetWidth === containerB.offsetWidth &&
                containerA.offsetHeight === containerB.offsetHeight;
        }

        function checkfont(font, DOM){
            var rootEle = html;
            if(DOM && DOM.children && DOM.children.length) rootEle = DOM.children[0];

            var result = null,
                reg = /[\,\.\/\;\'\[\]\`\<\>\\\?\:\"\{\}\|\~\!\@\#\$\%\^\&\*\(\)\-\=\_\+]/g,
                cleanUp = createContainers();

            font = font.replace(reg, "");

            rootEle.appendChild(containerA);
            rootEle.appendChild(containerB);

            //First Check
            containerA.style.fontFamily = font + ",monospace";
            containerB.style.fontFamily = "monospace";

            if(checkDimension()){
                //Assume Arial exists, Second Check
                containerA.style.fontFamily = font + ",Arial";
                containerB.style.fontFamily = "Arial";
                result = !checkDimension();
            }else{
                result = true;
            }

            cleanUp();
            return result
        }

        return checkfont(font, DOM);

    };

    return Utils;

});



// WEBPACK FOOTER //
// ./Private/Scripts/utils.js